import styled from 'styled-components';

import { ReactComponent as InformationIcon } from '../../../../../../assets/img/icons/bluetooth-module-01.svg';

export const Icon = styled(InformationIcon)`
  height: 96px;
  width: auto;
`;
